module.exports = __webpack_public_path__ + "static/img/wood61.9a7e942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood61.jpg
// module id = cymk
// module chunks = 0